"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { COLORS } from "./chartColors";
import { sortLabelsChronologically } from "./helpers/dateHelpers";
import { parseDataKey } from "./helpers/dataHelpers";
import { groupByPeriodAndKey } from "./helpers/dataGroupingHelpers";
const formatStateName = (state) => {
  return state.split("_").map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ");
};
export const applicationCountStatusTransformer = (data, selectedEntities, selectedStatuses = []) => {
  const allRecords = [];
  Object.entries(data).forEach(([key, value]) => {
    const { monthLabel, shouldInclude } = parseDataKey(key, selectedEntities);
    if (!shouldInclude) return;
    if (Array.isArray(value.data)) {
      value.data.forEach((record) => {
        allRecords.push(__spreadProps(__spreadValues({}, record), { _periodLabel: monthLabel }));
      });
    }
  });
  const isAllStatesSelected = selectedStatuses == null ? void 0 : selectedStatuses.some(
    (stateFilter) => stateFilter.name === "All"
  );
  const filteredRecords = selectedStatuses && selectedStatuses.length > 0 && !isAllStatesSelected ? allRecords.filter(
    (record) => selectedStatuses.some(
      (stateFilter) => stateFilter.name === formatStateName(record.status || "unknown")
    )
  ) : allRecords;
  const monthlyStatusCounts = groupByPeriodAndKey(
    filteredRecords,
    (record) => record._periodLabel,
    (record) => record.status || "unknown"
  );
  const allStatuses = new Set(filteredRecords.map((r) => r.status || "unknown"));
  const sortedLabels = sortLabelsChronologically(Object.keys(monthlyStatusCounts));
  const datasets = Array.from(allStatuses).map((status, index) => ({
    label: formatStateName(status),
    data: sortedLabels.map((label) => monthlyStatusCounts[label][status] || 0),
    backgroundColor: COLORS[index % COLORS.length],
    borderWidth: 1,
    stack: "applicationStatus"
  }));
  return {
    labels: sortedLabels,
    datasets
  };
};
